import { useCallback } from "react";
import { useCurrentLocale } from "@repo/next-shared/hooks/useCurrentLocale";
import { usePathname, useSearchParams } from "next/navigation";
import { signIn } from "next-auth/react";

const IGNORED_PATHS = ["/login", "/logout"];

export const useRegistration = () => {
  const locale = useCurrentLocale();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const signInAction = useCallback(
    (register: boolean = false) => {
      const isIgnoredPath = IGNORED_PATHS.includes(pathname);
      const basePath = isIgnoredPath ? "/" : pathname;
      const params = new URLSearchParams(
        isIgnoredPath ? undefined : (searchParams?.toString() ?? ""),
      );
      params.set("fromLogin", "true");
      if (register) params.set("fromRegister", "true");

      return signIn(
        "keycloak",
        { redirectTo: `${basePath}?${params}` },
        {
          kc_locale: locale,
          ui_locales: locale,
          ...(register && { kc_action: "register" }),
        },
      );
    },
    [locale, pathname, searchParams],
  );

  return { signInAction };
};
